import LeftOutlined from '@ant-design/icons/lib/icons/LeftOutlined';
import { useNavigate } from 'react-router-dom';

export function GoBackButton({ onClick }: { onClick?: VoidFunction }) {
  const navigate = useNavigate();

  return (
    <div
      className="link-underline mb-8 flex cursor-pointer flex-row"
      onClick={() => {
        if (onClick) {
          onClick();
          return;
        }
        navigate(-1);
      }}
    >
      <LeftOutlined /> Go back
    </div>
  );
}
